import React from "react";

const VeritoneCommonReport = (props) => {
    const { as: Component, classes, id, ...remainProps} = props;
    let title = '';
    if(props.as.defaultProps && props.as.defaultProps.title) {
        title = props.as.defaultProps.title;
    } else if(props.title) {
        title = props.title
    }
    return (
        <div data-test= {title + "_commonChart"} className={classes.container} id={id}>
            <Component {...remainProps} classes={classes}/>
        </div>
    );
};

VeritoneCommonReport.defaultProps = {
    classes: {
        container: {}
    }
};

export default VeritoneCommonReport;
